import { Component, Input, OnInit, QueryList, ContentChildren } from '@angular/core';
import { HeaderDetailComponent } from './header-detail/header-detail.component';

@Component({
  selector: 'main-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @ContentChildren(HeaderDetailComponent) details: QueryList<HeaderDetailComponent>;
  @Input() title: string;
  @Input() description: string;
  @Input() icon: string;

  constructor() { }

  ngOnInit() {
  }

}
